import { saveAs } from 'file-saver';
import axiosInstance from './axios';

/**
 * Calls the backend to generate all approved submission docx files, zip them,
 * and download the zip.
 *
 * @param {string|null} typeId  - submission_type id, or null/"all" for all types
 * @param {string}      label   - human-readable label used in the zip filename
 */
const downloadBatchPreview = async (typeId, label) => {
    const params = {};
    if (typeId && typeId !== 'all') {
        params.type_id = typeId;
    }

    const res = await axiosInstance.get('/api/prv/operator-submissions/batch-preview', {
        params,
        responseType: 'blob',
    });

    const blob = new Blob([res.data], { type: 'application/zip' });
    const safeLabel = label ? label.replace(/[\\/:*?"<>|]/g, '_') : 'All';
    saveAs(blob, `Approved Abstract - ${safeLabel}.zip`);
};

export default downloadBatchPreview;
